import { render, staticRenderFns } from "./CampaignRecipientsTable.vue?vue&type=template&id=88814672&"
import script from "./CampaignRecipientsTable.vue?vue&type=script&lang=ts&"
export * from "./CampaignRecipientsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QMarkupTable} from 'quasar'
component.options.components = Object.assign({QMarkupTable}, component.options.components || {})
